import React from "react";
import PageHeading from "../../components/PageHeading";
import PopupMessageForm from "../../components/Forms/PopupMessageForm";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import popupServices from "../../services/popup";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { getCategories } from "../../redux/slicers/config";

const initialValues = {
  title: "",
  content: "",
  img_url: "",
};

const validationSchema = Yup.object().shape({
  title: Yup.string().required("هذا الحقل مطلوب"),
  content: Yup.string().required("هذا الحقل مطلوب"),
  img_url: Yup.string().required("هذا الحقل مطلوب"),
});
const AddPopup = ({ title }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const onSubmit = (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("content", values.content);
    formData.append("img_url", values.img_url);
    popupServices
      .addPupupMessage(formData)
      .then((res) => {
        toast.success("تمت الاضافة بنجاح");
        queryClient.refetchQueries("getAllPupupMessage");
        dispatch(getCategories());
        setTimeout(() => {
          navigate("/popup-messages");
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
        toast.error("فشلت الاضافة");
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
      });
  };
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <PopupMessageForm
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        initialValues={initialValues}
        btnText="اضافة رسالة"
      />
    </div>
  );
};

export default AddPopup;
